import { ClusterProduct } from '~/graphql/generated/graphql';
import { useConfigStore } from '~/stores/config';

/**
 * The rewards economy never renders on the schools product (CP-11267): no coins accrue there
 * and no prizes or campaigns run, so coin pills, prize chips and campaign banners would all
 * advertise something the server refuses. Nor does it render for an account labelled as a
 * schools account, which earns nothing on the public host either. Nor does it render for an
 * anonymous lesson participant: they hold no account to carry a balance, and nothing they earn
 * in the lesson may ever merge into one, so every figure on screen would be owed to nobody.
 * The frontend spelling of `SchoolsRewardSuppressionService`: one name for one rule on both
 * sides of the wire.
 */
export const useRewardsSuppressed = () => {
  const configStore = useConfigStore();
  const { isLessonGhost, user } = useAuth();

  return computed(() =>
    configStore.isSchoolsCluster
    || isLessonGhost.value
    || user.value?.accountProduct === ClusterProduct.Schools,
  );
};
